export default __webpack_public_path__ + "static/media/web_1_3.ed63cf16.png";